<template>
  <div class="container">
    <div class="personal-area">
      <div class="personal-sidebar">
        <div class="personal-sidebar-shadow">
          <div class="personal-avatar-container">
            <div class="personal-avatar">
              <div v-if="status === 'VIP'" class="personal-avatar-tag">
                <span>VIP</span>
              </div>
              <div style="position: relative">
                <img class="personal-avatar-image" :src="avatarUrl" />
                <img
                  class="personal-avatar-image-edit"
                  src="../../../images/icons/edit-pen.svg"
                  @click.prevent="navigate('details')"
                  alt="פרטים אישיים"
                  title="פרטים אישיים"
                />
              </div>
            </div>
          </div>
          <div class="personal-welcome">
            {{ $t("שלום") }},
            <span v-html="customerFullName"></span>
          </div>
        </div>
        <ul class="personal-nav">
          <li v-for="(page, i) in menu" :key="i">
            <a
              :href="page.link ? page.link : '#'"
              :class="{ active: isPage(page.slug) }"
              @click.prevent="navigate(page.redirect || page.slug, page.link)"
              >{{ page.label }}</a
            >
            <ul v-if="page.children && page.children.length">
              <li v-for="(subPage, j) in page.children" :key="j">
                <a
                  href="#"
                  :class="{ active: isPage(subPage.slug) }"
                  @click.prevent="navigate(subPage.slug)"
                  >{{ subPage.label }}</a
                >
              </li>
            </ul>
          </li>
          <li class="d-tablet d-desktop">
            <a href="#" @click.prevent="logout">{{ $t("התנתק") }}</a>
          </li>
        </ul>
        <div v-if="currentChildren.length" class="mobile-sub-nav">
          <button
            v-for="(page, i) in currentChildren"
            :key="i"
            @click="navigate(page.slug)"
            :class="{ active: isPage(page.slug) }"
          >
            {{ page.label }}
          </button>
        </div>
      </div>
      <div class="personal-body">
        <transition name="fade">
          <component
            :is="currentPage.component"
            v-bind="currentPage.props"
          ></component>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vacations from "./Vacations/Vacations.vue";
import Benefits from "./Benefits.vue";
import Survey from "./Survey.vue";
import Details from "./Details.vue";
import { api } from "../../API";
import { $t } from "../../i18n";

export default {
  components: {
    Vacations,
    Benefits,
    Survey,
    Details,
  },

  data() {
    return {
      siteData: window.siteData,
      pages: [
        {
          component: "Vacations",
          props: {
            view: "upcoming",
            vacations: siteData.customer_data.vacations,
            profile: siteData.customer_data.details,
          },
          slug: "vacations.upcoming",
        },
        {
          component: "Vacations",
          props: {
            view: "past",
            vacations: siteData.customer_data.vacations,
          },
          slug: "vacations.past",
        },
        {
          component: "Benefits",
          slug: "benefits",
          props: {
            benefits: window.siteData.benefits,
            about: window.siteData.benefits_about,
          },
        },
        {
          component: "Survey",
          slug: "survey",
        },
        {
          component: "Details",
          slug: "details",
          props: {
            profile: siteData.customer_data.details,
          },
        },
      ],
      menu: [
        {
          slug: "vacations",
          redirect: "vacations.upcoming",
          label: $t("חופשת הSKIDEAL שלי"),
          children: [
            {
              slug: "vacations.upcoming",
              label: $t("החופשות הקרובות"),
            },
            {
              slug: "vacations.past",
              label: $t("חופשות עבר"),
            },
          ],
        },
        // {
        // slug: "benefits",
        // label: $t("ההטבות שלי")
        // },
        // {
        //   slug: "survey",
        //   label: $t("שאלון גלישה")
        // },
        // {
        //   slug: "details",
        //   label: $t("פרטים"),
        // },
        // {
        //   slug: "corona",
        //   label: $t("הנחיות קורונה"),
        //   link: "/covid19-info/"
        // },
        {
          slug: "faq",
          label: $t("FAQ - שירות לקוחות"),
          link: "/QNA/",
        },
      ],
      route: {
        slug: "vacations.upcoming",
      },
    };
  },

  mounted() {
    if (this.siteData.show_discount) {
      const $modal = $(".personal-discount-modal");
      $modal.modal().show();
    }
  },

  computed: {
    currentPage() {
      return this.pages.find((p) => p.slug === this.route.slug);
    },
    currentChildren() {
      let children = [];
      this.menu.forEach((i) => {
        const prefix = this.route.slug.split(".")[0];
        if (i.slug.indexOf(prefix) === 0 && Array.isArray(i.children)) {
          children = i.children;
        }
      });
      return children;
    },
    customerFullName() {
      return `${siteData.customer_data.details.first_name} ${siteData.customer_data.details.last_name}`;
    },
    avatarUrl() {
      return siteData.customer_data.details.skideal_customer.avatar_url
        ? siteData.customer_data.details.skideal_customer.avatar_url
        : siteData.default_avatar_image_url;
    },
    status() {
      return siteData.customer_data.details.status;
    },
  },

  methods: {
    isPage(slug) {
      return this.route.slug.indexOf(slug) === 0;
    },

    navigate(slug, link = null) {
      if (link) {
        window.location.href = link;
        return;
      }

      this.route = {
        slug,
        props: {},
      };
    },

    logout() {
      api.customerLogout().finally(() => {
        window.location.href = "/";
      });
    },
  },
};
</script>
